import React from 'react';
import { useTranslation } from 'react-i18next';

import { FAQ_BASE_PATH } from '../../../../../config/constants';
import GenericCard from '../../../../GenericCard';
import type { SearchAllContentHit } from '../../../types';

import illustrationFaq from '../../../../../assets/images/illustrations/secondary/veelgesteldevragen.svg';

interface Props {
  hit: SearchAllContentHit;
  className: string;
}

const SearchAllContentResultsFaqHit: React.FC<Props> = (props) => {
  const { hit, className } = props;

  const { t } = useTranslation();

  // Theme path returns an array of paths, where the last item in the array
  // is equal to the path of the linked theme taxonomy term, and each item
  // before the last item in the array is a parent of that taxonomy term.
  //
  // Because the FAQ page that we want to link to only exists for the
  // parent theme, we want to get the first item of this array.
  //
  // If the hit object doesn't have this theme path property, it means
  // it isn't linked to any theme, so we return the default FAQ page.
  const themePath = hit.theme_path?.[0];
  const link = themePath ? `${FAQ_BASE_PATH}${themePath}#${hit.uuid[0]}` : FAQ_BASE_PATH;

  return (
    <GenericCard
      className={className}
      title={hit.page_title[0]}
      label={t('content_types.faq')}
      subtitle={hit.body?.[0]}
      link={link}
      image={illustrationFaq}
    />
  );
};

export default SearchAllContentResultsFaqHit;
